var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "layout debt-report" },
        [
          _c("link-modal", {
            ref: "linkModal",
            attrs: { title: "Ссылка на Google Таблицы" },
          }),
          _c("div", { staticClass: "layout-header" }, [
            _c("div", { staticClass: "layout-title" }, [
              _vm._v("Отчет по остатку задолженности"),
            ]),
            _c("div", { staticClass: "layout-header-actions" }, [
              _c(
                "div",
                { staticClass: "layout-header-action" },
                [
                  _c("c-button", {
                    attrs: {
                      size: "small",
                      icon: {
                        icon: "bookmark",
                        activeColor: "white",
                      },
                      tooltip: {
                        text: "Добавить в закладки",
                        activeText: "Убрать из закладок",
                      },
                      "active-color": "blue",
                      active: _vm.bookmark,
                    },
                    on: {
                      click: function ($event) {
                        _vm.bookmark = !_vm.bookmark
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-header-action" },
                [_c("google-form", { attrs: { sp: _vm.sp } })],
                1
              ),
            ]),
          ]),
          _c("debt-report-filters", {
            ref: "filters",
            staticClass: "debt-report__filters",
            on: {
              apply: _vm.applyFilters,
              inited: function ($event) {
                _vm.filtersInited = true
              },
            },
          }),
          _c("c-tabs", { attrs: { items: _vm.tabsItems, "with-routing": "" } }),
          _vm.filtersInited
            ? _c(
                "div",
                { staticClass: "debt-content" },
                [
                  _c("router-view", {
                    ref: "table",
                    attrs: {
                      workers: _vm.workers,
                      "charts-data": _vm.chartsData,
                      loading: _vm.loading,
                      page: _vm.page,
                      "filters-ref": _vm.$refs.filters,
                    },
                    on: {
                      apply: _vm.applyFilters,
                      nextPage: _vm.nextPage,
                      inited: _vm.onComponentInit,
                    },
                  }),
                ],
                1
              )
            : _c("c-loader", {
                staticClass: "mt-4",
                attrs: {
                  label: "Данные загружаются",
                  active: !_vm.filtersInited,
                  height: "300",
                },
              }),
        ],
        1
      ),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }